module.exports = __webpack_public_path__ + "./docs/img/big-icon-object.b01fef3afa5cab97afaa4239a1e81941.svg";